import { InteractionRequiredAuthError, BrowserAuthError } from "@azure/msal-browser";
import { loginRequest } from "auth/auth-config";
import { msalInstance } from "auth/msalInstance";

export const getAccessToken = async (): Promise<string | null> => {
    try {

        const accounts = msalInstance.getAllAccounts();

        if (accounts.length === 0) {
            console.warn("No accounts found. User may not be logged in.");
            return null;
        }

        const accessTokenRequest = {
            ...loginRequest,
            account: accounts[0], // Use the first account found
        };

        try {
            // Attempt to acquire the token silently
            const response = await msalInstance.acquireTokenSilent(accessTokenRequest);
            const accessToken = response.accessToken;
            return accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                // If silent acquisition fails, fallback to interactive method
                try {
                    const response = await msalInstance.acquireTokenPopup(accessTokenRequest);
                    const accessToken = response.accessToken;
                    return accessToken;
                } catch (popupError) {
                    console.error("Token acquisition via popup failed:", popupError);
                    return null;
                }
            } else {
                console.error("Silent token acquisition failed:", error);
                return null;
            }
        }
    } catch (error) {
        if (error instanceof BrowserAuthError && error.errorCode === "uninitialized_public_client_application") {
            console.error("MSAL instance was not initialized:", error);
        } else {
            console.error("An unexpected error occurred during token acquisition:", error);
        }
        return null;
    }
};
